<template>
	<div class="mdyJoinusCo">
		<div class="firstBoxMdy">
			<img class="mFirst" src="../../assets/dymanticLanshu/jijinghuiTopNewlist.jpg">
			<div class="mFirstBox">
				<div class="mFirstBoxImgBox" @click="open">
					<img class="mFirstBoxImg" src="../../assets/mImg/whiteMenu.png" alt="">
				</div>
			</div>
		</div>

		<el-drawer class="drawerBox" :visible.sync="drawer" :direction="direction" :before-close="handleClose"
			unique-opened>
			<el-menu :default-active="this.$route.path" class="el-menu-vertical-demo" @open="handleOpen"
				@close="handleCloseMenu" router>
				<el-menu-item index="/m">
					<i class="el-icon-s-home"></i>
					<span slot="title">首页</span>
				</el-menu-item>
				<el-menu-item index="/maboutLansu">
					<i class="el-icon-document"></i>
					<span slot="title">关于我们</span>
				</el-menu-item>
				<el-menu-item index="/mbrandLansu">
					<i class="el-icon-data-analysis"></i>
					<span slot="title">美业菩提</span>
				</el-menu-item>
				<el-submenu index="4">
					<template slot="title">
						<i class="el-icon-star-off"></i>
						<span>菩提基金会</span>
					</template>
					<el-menu-item-group>
						<el-menu-item index="/mdyIntroduce">基金会介绍</el-menu-item>
						<el-menu-item index="/mdyNews">基金会新闻</el-menu-item>
						<el-menu-item index="/mdyjoinus">联系我们</el-menu-item>
					</el-menu-item-group>
				</el-submenu>
				<el-submenu index="5">
					<template slot="title">
						<i class="el-icon-trophy"></i>
						<span>兰树品牌</span>
					</template>
					<el-menu-item-group>
						<el-menu-item index="/mhuaibrand">淮树</el-menu-item>
						<el-menu-item index="/mxinbrand">心清堂</el-menu-item>
						<el-menu-item index="/mshuibrand">水姻缘</el-menu-item>
						<el-menu-item index="/myibrand">一清堂</el-menu-item>
						<!-- 	<el-menu-item index="/mzhongbrand"><span>Dr.CHUNG<span style="vertical-align: super;">+</span></span></el-menu-item> -->
						<el-menu-item index="/mlanshuBrand">兰树</el-menu-item>
						<el-menu-item index="/mzbqfBrand">植本清方</el-menu-item>
					</el-menu-item-group>
				</el-submenu>
				<el-menu-item index="/mTrends">
					<i class="el-icon-bell"></i>
					<span slot="title">兰树动态</span>
				</el-menu-item>
			</el-menu>

		</el-drawer>
		<div class="breadBox">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/m' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>菩提基金会</el-breadcrumb-item>
				<el-breadcrumb-item>联系我们</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="breadLine"></div>
		<div class="baiduMapBox">
			<baidu-map class="bm-view" :center="center" :zoom="zoom" @ready="handler">
				<bm-info-window :position="center" title="浙江省杭州市上城区越秀维多利中心A座17楼" :show="show" @close="infoWindowClose"
					@open="infoWindowOpen">
					<p v-text="contents" class="styleContent"></p>
				</bm-info-window>
			</baidu-map>
		</div>
		<div class="dyJoinUsMain">
			<div class="dyJoinUsMainBox">
				<div class="joinBoxLeftTitle2 titleStyle1">联系电话</div>
				<div class="joinBoxLeftTitle3 titleStyle2">0571-89025888</div>
				<div class="joinBoxLeftTitle4 titleStyle1">联系邮箱</div>
				<div class="joinBoxLeftTitle5 titleStyle2">lasurgroup@lasur.com</div>
				<div class="joinBoxLeftTitle6 titleStyle1">联系地址</div>
				<div class="joinBoxLeftTitle7 titleStyle2">浙江省杭州市上城区越秀维多利中心 A座 17楼</div>
			</div>

			<div class="dyJoinUsMainInput">
				<el-input class="nameInput" placeholder="请输入您的姓名" prefix-icon="el-icon-s-custom" v-model="name">
				</el-input>

				<el-input class="phoneInput" placeholder="请输入您的电话" prefix-icon="el-icon-phone" v-model="telephone">
				</el-input>

				<el-input class="companyInput" placeholder="请输入您公司名称" prefix-icon="el-icon-office-building"
					v-model="corporate_name">
				</el-input>

				<el-input class="needsInput" type="textarea" :rows="8" placeholder="请输入您的需求" v-model="demand">
				</el-input>
			</div>

			<div class="submitBtnBox">
				<el-button class="submitBtn" type="primary" @click="submit()" round>马上提交</el-button>
			</div>
		</div>

		<div class="footerBoxMain">
			<div class="footerFirstLine">
				<li class="footerItem"><a target="_blank"
						href="https://huaishu.tmall.com/shop/view_shop.htm?spm=a230r.7195193.1997079397.2.124378dduXIhiW">淮树旗舰店</a>
				</li>
				<li class="footerItem"><a target="_blank"
						href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s">心清堂官方企业店</a>
				</li>
				<li class="footerItem"><a target="_blank" href="https://shop349169226.taobao.com/?spm=a21xtw.29978516.0.0">水姻缘旗舰店</a></li>
			</div>
			<div class="footerSecondLine">
				<li class="footerItem"><a target="_blank"
						href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s">一清堂官方企业店</a>
				</li>
				<li class="footerItem"><a target="_blank" href="https://drchung.tmall.com" ><span>Dr.CHUNG<span style="vertical-align: super;">+</span></span>旗舰店</a></li>
				<li class="footerItem"><a target="_blank" href="https://zhibenqingfang.tmall.com">植本清方旗舰店</a></li>
				<div class="lastHeader">
					<li>
						<router-link to="/maboutLansu" tag="a">登录</router-link>
					</li>
					|
					<li>
						<router-link to="/m" tag="a">注册</router-link>
					</li>
				</div>
			</div>
			<div class="footerBoxHeader">
				<div class="footerBoxHeaderLeft">
					<img class="codeImg" src="../../assets/code.png" alt="">
					<span class="codeText">兰树公众号</span>
				</div>
				<div class="footerBoxHeaderRight">
					<img class="codeImg" src="../../assets/xcxNew.jpg" alt="">
					<span class="codeText">兰树云小程序</span>
				</div>
			</div>
			<div class="footerInfoBox">
				<div class="emailBox">邮箱: lasur@lasur.com</div>
				<div class="phoneBox">电话: 0571-89025888</div>
				<div class="addressBox">地址: 浙江省杭州市之江东路越秀·维多利中心A座 17楼</div>
			</div>
			<div class="footerLine"></div>
			<div class="footerBoxBottom">
				<div class="footerLeft">
					Copyright © 2023 兰树化妆品股份有限公司
				</div>
				<div class="footerLeft">
					<a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备20018890号-1</a><br />
					<img
						src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2022-09-13_13-29-23_21054.png" /><a
						target="_blank"
						href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33052102000740">浙公网安备
						33052102000740号</a>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import { myGet, myPost, login } from "../../api/http.js";
import { nav_js } from "../../navigation/js/bootsnav.js";
export default {
	data() {
		return {
			center: { lng: 0, lat: 0 },
			zoom: 3,
			show: true,
			contents: '0571-89025888',
			name: '',
			telephone: '',
			corporate_name: '',
			demand: '',
			drawer: false,
			direction: 'ltr'
		}
	},
	created() {
		nav_js();
	},
	methods: {
		handler({ BMap, map }) {
			console.log(BMap, map)
			this.center.lng = 120.239058;
			this.center.lat = 30.273104;
			this.zoom = 15
		},
		infoWindowClose(e) {
			this.show = false
		},
		clear() {
			this.contents = ''
		},
		infoWindowOpen(e) {
			this.show = true
		},
		//提交表单
		submit() {
			myPost("api/demand/", {
				name: this.name,
				telephone: this.telephone,
				corporate_name: this.corporate_name,
				demand: this.demand,
			}).then((res) => {
				if (res.data.code == 200) {
					this.$message.success('提交成功！')
					this.name = '',
						this.telephone = '',
						this.corporate_name = '',
						this.demand = ''
				} else {
					this.$message.error('提交失败！')
				}
			})
		},
		handleClose(done) {
			done()
		},
		open() {
			this.drawer = true
		},
		handleOpen(key, keyPath) {
			console.log(key, keyPath);
		},
		handleCloseMenu(key, keyPath) {
			console.log(key, keyPath);
		}
	}
}
</script>

<style scoped>
.mdyJoinusCo {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.mFirst {
	width: 100%;
}

.mFirstBox {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 99;
}


.mFirstBoxImgBox {
	width: 100%;
	margin-top: 0.5rem;
}

.mFirstBoxImg {
	width: 50%;
	float: left;
	position: relative;
	left: 0.5rem;
}

.firstBoxMdy {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}


.breadBox {
	display: flex;
	margin-top: 1rem;
}

.breadLine {
	width: 100%;
	height: 1px;
	background-color: #E8E8E8;
	margin-top: 1rem;
}


.baiduMapBox {
	width: 100%;
}

.bm-view {
	width: 100%;
	height: 280px;
}


.dyJoinUsMain {
	width: 100%;
	display: flex;
	flex-direction: column;
	padding-bottom: 2rem;
}


.dyJoinUsMainBox {
	width: 80%;
	display: flex;
	flex-direction: column;
	margin: 0 auto;
}


.titleStyle1 {
	font-size: 0.75em;
	font-weight: 400;
	color: #666666;
	line-height: 17px;
	margin-top: 2em;
}

.titleStyle2 {
	font-size: 0.875em;
	font-weight: 400;
	color: #212121;
	line-height: 20px;
}

.dyJoinUsMainInput {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-bottom: 1rem;
}

.footerBoxMain {
	width: 100%;
	min-height: 620px;
	background-color: #F9F9F9;
	display: flex;
	flex-direction: column;
	align-items: center;
}



.footerFirstLine {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 0 auto;
	justify-content: center;
	margin-top: 1rem;
}

.footerSecondLine {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 0 auto;
	justify-content: center;
	margin-top: 0.5rem;
}

.footerItem {
	list-style: none;
}

.footerItem a {
	color: #333333;
	font-size: 0.9375rem;
	text-decoration: none;
	margin-left: 0.5rem;
}

.lastHeader {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	font-size: 0.9375em;
	color: #333333;
	line-height: 28px;
	margin-left: 1rem;
}

.lastHeader li a {
	text-decoration: none;
	font-size: 0.9375rm;
	color: #333333;
	line-height: 28px;
}

.lastHeader li {
	list-style: none;
}

.footerBoxHeader {
	width: 60%;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin-top: 1rem;
}

.footerBoxHeaderLeft,
.footerBoxHeaderRight {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-direction: column;
	flex-direction: column;
	-ms-flex-align: center;
	align-items: center;
}

.codeImg {
	width: 100%;
}

.codeText {
	font-size: 0.88em;
	color: #333333;
	line-height: 20px;
	/* margin-top: 0em; */
}


.footerInfoBox {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 1rem;
}

.emailBox {
	font-size: 0.875rem;
	color: #333333;
	line-height: 20px;
}


.phoneBox {
	font-size: 0.875rem;
	color: #333333;
	line-height: 20px;
	margin-top: 0.5rem;
}

.addressBox {
	font-size: 0.875rem;
	color: #333333;
	line-height: 20px;
	margin-top: 0.5rem;
	text-align: center;
}

.footerLine {
	width: 100%;
	height: 1px;
	display: flex;
	background: #333333;
	opacity: 0.1;
	margin: 0 auto;
	align-items: center;
	margin-top: 0.5rem;
}

.footerBoxBottom {
	display: flex;
	margin: 0 auto;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	margin-top: 1rem;
}

.footerLeft {
	text-align: center;
	font-size: 0.9em;
	color: #333333;
	line-height: 24px;
}

.footerLeft a {
	text-decoration: none;
	cursor: pointer;
	color: #333333;
}


.nameInput {
	width: 80%;
	outline: none;
	margin-top: 1rem;
}

.companyInput {
	width: 80%;
	outline: none;
	margin-top: 1rem;
}

.phoneInput {
	width: 80%;
	outline: none;
	margin-top: 1rem;
}

.needsInput {
	width: 80%;
	outline: none;
	margin-top: 1rem;
}

.submitBtn {
	width: 8em;
}

.submitBtnBox {
	width: 80%;
	margin: 0 auto;
	display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/mComponents/mdynamticJoinus.vue